export const state = {
    attempts: [],
    username: localStorage.getItem('username'),
    profilePic: localStorage.getItem('pic'),
    usermodules: localStorage.getItem('rm')
};
export default state


// WEBPACK FOOTER //
// ./src/vuex/modules/auth/state.js